module.exports = __webpack_public_path__ + "6b274a2e83f6a653f9a5ba73ba3c792e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/1_C2.mp3
// module id = 98
// module chunks = 0